import { createFileRoute } from '@tanstack/react-router'
import { PartnerRouteGuard } from '../../components/PartnerRouteGuard'
import { CohortPage } from '../../components/PartnerCohorts'
import { CohortPageV2 } from '../../components/PartnerCohorts/redesign/CohortPageV2'
import { isNewCohortDesignDevOverride } from '../../components/PartnerCohorts/redesign/newCohortDesignFlag'
import { useOrganizationAdminSettings } from '../../hooks/useOrganizationSettings'

export const Route = createFileRoute('/partner/c/$id')({
  component: () => {
    const { id } = Route.useParams()
    const { getOrgAdminSetting } = useOrganizationAdminSettings()
    const useNew = (getOrgAdminSetting('useNewCohortDesign') ?? false) || isNewCohortDesignDevOverride()

    return (
      <PartnerRouteGuard>
        {useNew ? <CohortPageV2 cohortId={id} /> : <CohortPage cohortId={id} />}
      </PartnerRouteGuard>
    )
  },
})
